<template>
  <div class="layout my-talks">
    <div class="tab_nav">
      <div class="nav_item" :class="{ is_active: index == actIndex }" @click="tabChange(index)" v-for="(item, index) in navList" :key="index">{{ item }}</div>
    </div>
    <div class="tab_content">
      <myUser v-if="actIndex == 0"></myUser>
      <myService v-if="actIndex == 1"></myService>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import myUser from "./components/my-user"; //我的客户
import myService from "./components/my-service"; //我的客服
export default {
  name: "my-talks",
  components: {
    myUser,
    myService,
  },
  data() {
    return {
      actIndex: 0,
      navList: ["My customer", "Exhibitors"],
    };
  },
  async created() {
    if (this.$route.params.id) {
      this.$store.commit("setExhibitionId", this.$route.params.id);
    }
    if (!this.userInfo) {
      await this.$Myapollo.getUserInfo(this);
    }
    this.$Myapollo.addExhibitionView();
    this.actIndex = this.myTalksHead;
    // if(!this.exhibitionInfo&&this.exhibitionId){
    //   await this.$Myapollo.getExhibitionInfo(this,this.exhibitionId,this.userInfo.userId);
    // }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
      myTalksHead: "getMyTalksHead",
      // exhibitionInfo:"getExhibitionInfo"
    }),
  },
  methods: {
    ...mapActions({
      graphqlPost: "graphqlPostByZXS",
      LinkChatTalk: "linkTo/LinkChatTalk",
      LinkChatTalkUser: "linkTo/LinkChatTalkUser",
    }),
    tabChange(i) {
      if (this.actIndex == i) {
        return;
      }
      this.actIndex = i;
      this.$store.commit("setMyTalksHead", i);
    },
  },
};
</script>

<style lang="scss" scoped>
.my-talks {
  background: #fff;
  padding-bottom: 0;
  .tab_nav {
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    height: 0.9rem;
    width: 100%;
    display: flex;
    z-index: 99;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.02rem;
    border-bottom: 1px solid #e6e6e6;
    .nav_item {
      color: #666;
      width: 2rem;
      height: 0.48rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.48rem;
      font-size: 0.26rem;
      &.is_active {
        color: #fff;
        background: #1890ff;
      }
    }
  }
  .tab_content {
    padding: 0.9rem 0 0.3rem;
  }
}
</style>
